"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgDistanceToAirport = function SvgDistanceToAirport(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m15.618 12.682-4.574 2.842s-1.214.957-3.503.478c-2.29-.478-4.638-1.004-4.638-1.004s-.503-.185-.85.27c-.348.456.224.728.224.728l3.531 2.592s.753.755 1.862.557c1.11-.198 4.37-.87 4.37-.87s2.227-.48 4.875-2.154c2.647-1.674 12.11-7.494 12.11-7.494s3.684-2.12 3.315-3.009c-.37-.888-2.493-.65-3.508-.325-1.016.325-8.94 4.875-8.94 4.875l-8.685-3.016s-1.123-.27-.562.394c.562.664 6.065 6.214 6.065 6.214m3.76 2.668 2.36 2.384s.685.55.823-1.364c.138-1.915.277-3.348.277-3.348M2.832 26.213v12.005h33.835",
    stroke: "#C2C5CC"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.744 26.086a1.078 1.078 0 1 0 0-2.156 1.078 1.078 0 0 0 0 2.156ZM4.6 25.048s4.371-.16 6.96 1.445c2.588 1.606 8.534 0 8.534 0s1.212-.238 1.61.701c.397.939-.747 1.862-.747 1.862s-3.495 2.176-7.358 2.176c-3.863 0-5.526-1.268-8.998 0 .023-3.207 0-6.184 0-6.184Z",
    stroke: "#C2C5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.58 25.408-.62 5.27m4.097-3.848-.891 4.23m3.747-3.709.447 3.829m2.048-4.042 1.155 3.11",
    stroke: "#C2C5CC"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgDistanceToAirport);
var _default = exports["default"] = Memo;